
import { computed, defineComponent, reactive } from 'vue';
import { Card } from 'ant-design-vue';
import { INotaFiscalDetalhePagamento } from '@/models/Entidades/Fiscal/INotaFiscal';
import NotaFiscalDetalhePagamentoCentroCusto from '@/components/Fiscal/NotasFiscais/NotaFiscalDetalhePagamentoCentroCusto.vue';
import { useModalBase } from '@/core/composables/ModalBase';

export default defineComponent({
  name: 'RecebimentoMercadoriaCentroCustoModal',
  props: {
    visivel: {
      type: Boolean,
      required: true,
    },
    detalhePagamento: {
      type: Object as () => INotaFiscalDetalhePagamento,
      required: true,
    },
  },
  components: {
    Card,
    NotaFiscalDetalhePagamentoCentroCusto,
  },
  emits: ['update:detalhePagamento', 'confirmar'],
  setup(props, { emit }) {
    const state = reactive({
      telaMobile: false,
    });
    const { modalBase } = useModalBase(props, emit);

    const computedDetalhePagamento = computed({
      get: () => props.detalhePagamento,
      set: (val: INotaFiscalDetalhePagamento) => {
        emit('update:detalhePagamento', val);
      },
    });

    function cancelar() {
      modalBase.computedVisivel = false;
    }

    function salvar() {
      emit('confirmar');
      modalBase.computedVisivel = false;
    }

    return {
      props,
      state,
      computedDetalhePagamento,
      modalBase,
      salvar,
      cancelar,
    };
  },
});
